import {z} from 'zod'
import {EnvironmentName} from '../EnvironmentName.js'

export const WsProxyEnvironmentVariables = z.object({
  ENVIRONMENT_NAME: EnvironmentName,
  API_RESOLVER_LAMBDA_FUNCTION_NAME: z.string(),
})

export type WsProxyEnvironmentVariables = z.infer<typeof WsProxyEnvironmentVariables>
